module.exports = __webpack_public_path__ + "media/img/frontend_application/banner/eo-outside-sg/mobile-4ecc7c7ac23f879044c8cd95e0e3b786.png";